export default "__VITE_ASSET__Cyn0f02W__"